module.exports = __webpack_public_path__ + "static/media/carefree.dddbb009.jpg";